export const PERCENTAGE_OF_POINT_USED = 'custom7'
